/**
 * GENERATED FILE - DO NOT EDIT
 * Generated by scripts/sync-tailwind-metadata.mjs
 */

export const STATIC_UTILITIES = new Set([
	'-bottom-full',
	'-bottom-px',
	'-end-full',
	'-end-px',
	'-indent-px',
	'-inset-full',
	'-inset-px',
	'-inset-x-full',
	'-inset-x-px',
	'-inset-y-full',
	'-inset-y-px',
	'-left-full',
	'-left-px',
	'-m-px',
	'-mb-px',
	'-me-px',
	'-ml-px',
	'-mr-px',
	'-ms-px',
	'-mt-px',
	'-mx-px',
	'-my-px',
	'-right-full',
	'-right-px',
	'-scroll-m-px',
	'-scroll-mb-px',
	'-scroll-me-px',
	'-scroll-ml-px',
	'-scroll-mr-px',
	'-scroll-ms-px',
	'-scroll-mt-px',
	'-scroll-mx-px',
	'-scroll-my-px',
	'-space-x-px',
	'-space-y-px',
	'-start-full',
	'-start-px',
	'-top-full',
	'-top-px',
	'-translate-full',
	'-translate-px',
	'-translate-x-full',
	'-translate-x-px',
	'-translate-y-full',
	'-translate-y-px',
	'-translate-z-px',
	'absolute',
	'accent-auto',
	'align-baseline',
	'align-bottom',
	'align-middle',
	'align-sub',
	'align-super',
	'align-text-bottom',
	'align-text-top',
	'align-top',
	'antialiased',
	'appearance-auto',
	'appearance-none',
	'backface-hidden',
	'backface-visible',
	'basis-auto',
	'basis-full',
	'basis-px',
	'bg-auto',
	'bg-blend-color',
	'bg-blend-color-burn',
	'bg-blend-color-dodge',
	'bg-blend-darken',
	'bg-blend-difference',
	'bg-blend-exclusion',
	'bg-blend-hard-light',
	'bg-blend-hue',
	'bg-blend-lighten',
	'bg-blend-luminosity',
	'bg-blend-multiply',
	'bg-blend-normal',
	'bg-blend-overlay',
	'bg-blend-saturation',
	'bg-blend-screen',
	'bg-blend-soft-light',
	'bg-bottom',
	'bg-bottom-left',
	'bg-bottom-right',
	'bg-center',
	'bg-clip-border',
	'bg-clip-content',
	'bg-clip-padding',
	'bg-clip-text',
	'bg-contain',
	'bg-cover',
	'bg-fixed',
	'bg-gradient-to-b',
	'bg-gradient-to-bl',
	'bg-gradient-to-br',
	'bg-gradient-to-l',
	'bg-gradient-to-r',
	'bg-gradient-to-t',
	'bg-gradient-to-tl',
	'bg-gradient-to-tr',
	'bg-left',
	'bg-left-bottom',
	'bg-left-top',
	'bg-local',
	'bg-no-repeat',
	'bg-none',
	'bg-origin-border',
	'bg-origin-content',
	'bg-origin-padding',
	'bg-repeat',
	'bg-repeat-round',
	'bg-repeat-space',
	'bg-repeat-x',
	'bg-repeat-y',
	'bg-right',
	'bg-right-bottom',
	'bg-right-top',
	'bg-scroll',
	'bg-top',
	'bg-top-left',
	'bg-top-right',
	'block',
	'border-collapse',
	'border-dashed',
	'border-dotted',
	'border-double',
	'border-hidden',
	'border-none',
	'border-separate',
	'border-solid',
	'border-spacing-px',
	'border-spacing-x-px',
	'border-spacing-y-px',
	'bottom-auto',
	'bottom-full',
	'bottom-px',
	'box-border',
	'box-content',
	'box-decoration-clone',
	'box-decoration-slice',
	'break-after-all',
	'break-after-auto',
	'break-after-avoid',
	'break-after-avoid-page',
	'break-after-column',
	'break-after-left',
	'break-after-page',
	'break-after-right',
	'break-all',
	'break-before-all',
	'break-before-auto',
	'break-before-avoid',
	'break-before-avoid-page',
	'break-before-column',
	'break-before-left',
	'break-before-page',
	'break-before-right',
	'break-inside-auto',
	'break-inside-avoid',
	'break-inside-avoid-column',
	'break-inside-avoid-page',
	'break-keep',
	'break-normal',
	'break-words',
	'capitalize',
	'caption-bottom',
	'caption-top',
	'clear-both',
	'clear-end',
	'clear-left',
	'clear-none',
	'clear-right',
	'clear-start',
	'collapse',
	'contain-content',
	'contain-inline-size',
	'contain-layout',
	'contain-none',
	'contain-paint',
	'contain-size',
	'contain-strict',
	'contain-style',
	'container',
	'content-around',
	'content-baseline',
	'content-between',
	'content-center',
	'content-center-safe',
	'content-end',
	'content-end-safe',
	'content-evenly',
	'content-none',
	'content-normal',
	'content-start',
	'content-stretch',
	'contents',
	'cursor-alias',
	'cursor-all-scroll',
	'cursor-auto',
	'cursor-cell',
	'cursor-col-resize',
	'cursor-context-menu',
	'cursor-copy',
	'cursor-crosshair',
	'cursor-default',
	'cursor-e-resize',
	'cursor-ew-resize',
	'cursor-grab',
	'cursor-grabbing',
	'cursor-help',
	'cursor-move',
	'cursor-n-resize',
	'cursor-ne-resize',
	'cursor-nesw-resize',
	'cursor-no-drop',
	'cursor-none',
	'cursor-not-allowed',
	'cursor-ns-resize',
	'cursor-nw-resize',
	'cursor-nwse-resize',
	'cursor-pointer',
	'cursor-progress',
	'cursor-row-resize',
	'cursor-s-resize',
	'cursor-se-resize',
	'cursor-sw-resize',
	'cursor-text',
	'cursor-vertical-text',
	'cursor-w-resize',
	'cursor-wait',
	'cursor-zoom-in',
	'cursor-zoom-out',
	'decoration-auto',
	'decoration-clone',
	'decoration-dashed',
	'decoration-dotted',
	'decoration-double',
	'decoration-from-font',
	'decoration-slice',
	'decoration-solid',
	'decoration-wavy',
	'diagonal-fractions',
	'divide-dashed',
	'divide-dotted',
	'divide-double',
	'divide-none',
	'divide-solid',
	'divide-x-reverse',
	'divide-y-reverse',
	'drop-shadow-none',
	'duration-initial',
	'end-auto',
	'end-full',
	'end-px',
	'field-sizing-content',
	'field-sizing-fixed',
	'fill-none',
	'fixed',
	'flex',
	'flex-auto',
	'flex-col',
	'flex-col-reverse',
	'flex-initial',
	'flex-none',
	'flex-nowrap',
	'flex-row',
	'flex-row-reverse',
	'flex-wrap',
	'flex-wrap-reverse',
	'float-end',
	'float-left',
	'float-none',
	'float-right',
	'float-start',
	'flow-root',
	'font-stretch-condensed',
	'font-stretch-expanded',
	'font-stretch-extra-condensed',
	'font-stretch-extra-expanded',
	'font-stretch-normal',
	'font-stretch-semi-condensed',
	'font-stretch-semi-expanded',
	'font-stretch-ultra-condensed',
	'font-stretch-ultra-expanded',
	'forced-color-adjust-auto',
	'forced-color-adjust-none',
	'gap-px',
	'gap-x-px',
	'gap-y-px',
	'grid',
	'grid-flow-col',
	'grid-flow-col-dense',
	'grid-flow-dense',
	'grid-flow-row',
	'grid-flow-row-dense',
	'h-auto',
	'h-dvh',
	'h-dvw',
	'h-fit',
	'h-full',
	'h-lh',
	'h-lvh',
	'h-lvw',
	'h-max',
	'h-min',
	'h-px',
	'h-screen',
	'h-svh',
	'h-svw',
	'hidden',
	'hyphens-auto',
	'hyphens-manual',
	'hyphens-none',
	'indent-px',
	'inline',
	'inline-block',
	'inline-flex',
	'inline-grid',
	'inline-table',
	'inset-auto',
	'inset-full',
	'inset-px',
	'inset-shadow-initial',
	'inset-x-auto',
	'inset-x-full',
	'inset-x-px',
	'inset-y-auto',
	'inset-y-full',
	'inset-y-px',
	'invisible',
	'isolate',
	'isolation-auto',
	'italic',
	'items-baseline',
	'items-baseline-last',
	'items-center',
	'items-center-safe',
	'items-end',
	'items-end-safe',
	'items-start',
	'items-stretch',
	'justify-around',
	'justify-baseline',
	'justify-between',
	'justify-center',
	'justify-center-safe',
	'justify-end',
	'justify-end-safe',
	'justify-evenly',
	'justify-items-center',
	'justify-items-center-safe',
	'justify-items-end',
	'justify-items-end-safe',
	'justify-items-normal',
	'justify-items-start',
	'justify-items-stretch',
	'justify-normal',
	'justify-self-auto',
	'justify-self-center',
	'justify-self-center-safe',
	'justify-self-end',
	'justify-self-end-safe',
	'justify-self-start',
	'justify-self-stretch',
	'justify-start',
	'justify-stretch',
	'leading-px',
	'left-auto',
	'left-full',
	'left-px',
	'line-through',
	'lining-nums',
	'list-inside',
	'list-item',
	'list-outside',
	'lowercase',
	'm-auto',
	'm-px',
	'mask-add',
	'mask-alpha',
	'mask-auto',
	'mask-bottom',
	'mask-bottom-left',
	'mask-bottom-right',
	'mask-center',
	'mask-circle',
	'mask-clip-border',
	'mask-clip-content',
	'mask-clip-fill',
	'mask-clip-padding',
	'mask-clip-stroke',
	'mask-clip-view',
	'mask-contain',
	'mask-cover',
	'mask-ellipse',
	'mask-exclude',
	'mask-intersect',
	'mask-left',
	'mask-luminance',
	'mask-match',
	'mask-no-clip',
	'mask-no-repeat',
	'mask-none',
	'mask-origin-border',
	'mask-origin-content',
	'mask-origin-fill',
	'mask-origin-padding',
	'mask-origin-stroke',
	'mask-origin-view',
	'mask-radial-at-bottom',
	'mask-radial-at-bottom-left',
	'mask-radial-at-bottom-right',
	'mask-radial-at-center',
	'mask-radial-at-left',
	'mask-radial-at-right',
	'mask-radial-at-top',
	'mask-radial-at-top-left',
	'mask-radial-at-top-right',
	'mask-radial-closest-corner',
	'mask-radial-closest-side',
	'mask-radial-farthest-corner',
	'mask-radial-farthest-side',
	'mask-repeat',
	'mask-repeat-round',
	'mask-repeat-space',
	'mask-repeat-x',
	'mask-repeat-y',
	'mask-right',
	'mask-subtract',
	'mask-top',
	'mask-top-left',
	'mask-top-right',
	'mask-type-alpha',
	'mask-type-luminance',
	'max-h-dvh',
	'max-h-dvw',
	'max-h-fit',
	'max-h-full',
	'max-h-lh',
	'max-h-lvh',
	'max-h-lvw',
	'max-h-max',
	'max-h-min',
	'max-h-none',
	'max-h-px',
	'max-h-screen',
	'max-h-svh',
	'max-h-svw',
	'max-w-dvh',
	'max-w-dvw',
	'max-w-fit',
	'max-w-full',
	'max-w-lvh',
	'max-w-lvw',
	'max-w-max',
	'max-w-min',
	'max-w-none',
	'max-w-px',
	'max-w-screen',
	'max-w-svh',
	'max-w-svw',
	'mb-auto',
	'mb-px',
	'me-auto',
	'me-px',
	'min-h-auto',
	'min-h-dvh',
	'min-h-dvw',
	'min-h-fit',
	'min-h-full',
	'min-h-lh',
	'min-h-lvh',
	'min-h-lvw',
	'min-h-max',
	'min-h-min',
	'min-h-px',
	'min-h-screen',
	'min-h-svh',
	'min-h-svw',
	'min-w-auto',
	'min-w-dvh',
	'min-w-dvw',
	'min-w-fit',
	'min-w-full',
	'min-w-lvh',
	'min-w-lvw',
	'min-w-max',
	'min-w-min',
	'min-w-px',
	'min-w-screen',
	'min-w-svh',
	'min-w-svw',
	'mix-blend-color',
	'mix-blend-color-burn',
	'mix-blend-color-dodge',
	'mix-blend-darken',
	'mix-blend-difference',
	'mix-blend-exclusion',
	'mix-blend-hard-light',
	'mix-blend-hue',
	'mix-blend-lighten',
	'mix-blend-luminosity',
	'mix-blend-multiply',
	'mix-blend-normal',
	'mix-blend-overlay',
	'mix-blend-plus-darker',
	'mix-blend-plus-lighter',
	'mix-blend-saturation',
	'mix-blend-screen',
	'mix-blend-soft-light',
	'ml-auto',
	'ml-px',
	'mr-auto',
	'mr-px',
	'ms-auto',
	'ms-px',
	'mt-auto',
	'mt-px',
	'mx-auto',
	'mx-px',
	'my-auto',
	'my-px',
	'no-underline',
	'normal-case',
	'normal-nums',
	'not-italic',
	'not-sr-only',
	'object-contain',
	'object-cover',
	'object-fill',
	'object-left-bottom',
	'object-left-top',
	'object-none',
	'object-right-bottom',
	'object-right-top',
	'object-scale-down',
	'oldstyle-nums',
	'order-none',
	'ordinal',
	'outline-dashed',
	'outline-dotted',
	'outline-double',
	'outline-hidden',
	'outline-none',
	'outline-solid',
	'overflow-auto',
	'overflow-clip',
	'overflow-ellipsis',
	'overflow-hidden',
	'overflow-scroll',
	'overflow-visible',
	'overflow-x-auto',
	'overflow-x-clip',
	'overflow-x-hidden',
	'overflow-x-scroll',
	'overflow-x-visible',
	'overflow-y-auto',
	'overflow-y-clip',
	'overflow-y-hidden',
	'overflow-y-scroll',
	'overflow-y-visible',
	'overline',
	'overscroll-auto',
	'overscroll-contain',
	'overscroll-none',
	'overscroll-x-auto',
	'overscroll-x-contain',
	'overscroll-x-none',
	'overscroll-y-auto',
	'overscroll-y-contain',
	'overscroll-y-none',
	'p-px',
	'pb-px',
	'pe-px',
	'pl-px',
	'place-content-around',
	'place-content-baseline',
	'place-content-between',
	'place-content-center',
	'place-content-center-safe',
	'place-content-end',
	'place-content-end-safe',
	'place-content-evenly',
	'place-content-start',
	'place-content-stretch',
	'place-items-baseline',
	'place-items-center',
	'place-items-center-safe',
	'place-items-end',
	'place-items-end-safe',
	'place-items-start',
	'place-items-stretch',
	'place-self-auto',
	'place-self-center',
	'place-self-center-safe',
	'place-self-end',
	'place-self-end-safe',
	'place-self-start',
	'place-self-stretch',
	'pointer-events-auto',
	'pointer-events-none',
	'pr-px',
	'proportional-nums',
	'ps-px',
	'pt-px',
	'px-px',
	'py-px',
	'relative',
	'resize',
	'resize-none',
	'resize-x',
	'resize-y',
	'right-auto',
	'right-full',
	'right-px',
	'ring-inset',
	'rotate-none',
	'scale-3d',
	'scale-none',
	'scheme-dark',
	'scheme-light',
	'scheme-light-dark',
	'scheme-normal',
	'scheme-only-dark',
	'scheme-only-light',
	'scroll-auto',
	'scroll-m-px',
	'scroll-mb-px',
	'scroll-me-px',
	'scroll-ml-px',
	'scroll-mr-px',
	'scroll-ms-px',
	'scroll-mt-px',
	'scroll-mx-px',
	'scroll-my-px',
	'scroll-p-px',
	'scroll-pb-px',
	'scroll-pe-px',
	'scroll-pl-px',
	'scroll-pr-px',
	'scroll-ps-px',
	'scroll-pt-px',
	'scroll-px-px',
	'scroll-py-px',
	'scroll-smooth',
	'select-all',
	'select-auto',
	'select-none',
	'select-text',
	'self-auto',
	'self-baseline',
	'self-baseline-last',
	'self-center',
	'self-center-safe',
	'self-end',
	'self-end-safe',
	'self-start',
	'self-stretch',
	'shadow-initial',
	'size-auto',
	'size-dvh',
	'size-dvw',
	'size-fit',
	'size-full',
	'size-lvh',
	'size-lvw',
	'size-max',
	'size-min',
	'size-px',
	'size-svh',
	'size-svw',
	'slashed-zero',
	'snap-align-none',
	'snap-always',
	'snap-both',
	'snap-center',
	'snap-end',
	'snap-mandatory',
	'snap-none',
	'snap-normal',
	'snap-proximity',
	'snap-start',
	'snap-x',
	'snap-y',
	'space-x-px',
	'space-x-reverse',
	'space-y-px',
	'space-y-reverse',
	'sr-only',
	'stacked-fractions',
	'start-auto',
	'start-full',
	'start-px',
	'static',
	'sticky',
	'stroke-none',
	'subpixel-antialiased',
	'table',
	'table-auto',
	'table-caption',
	'table-cell',
	'table-column',
	'table-column-group',
	'table-fixed',
	'table-footer-group',
	'table-header-group',
	'table-row',
	'table-row-group',
	'tabular-nums',
	'text-balance',
	'text-center',
	'text-clip',
	'text-ellipsis',
	'text-end',
	'text-justify',
	'text-left',
	'text-nowrap',
	'text-pretty',
	'text-right',
	'text-shadow-initial',
	'text-start',
	'text-wrap',
	'top-auto',
	'top-full',
	'top-px',
	'touch-auto',
	'touch-manipulation',
	'touch-none',
	'touch-pan-down',
	'touch-pan-left',
	'touch-pan-right',
	'touch-pan-up',
	'touch-pan-x',
	'touch-pan-y',
	'touch-pinch-zoom',
	'transform-3d',
	'transform-border',
	'transform-content',
	'transform-cpu',
	'transform-fill',
	'transform-flat',
	'transform-gpu',
	'transform-none',
	'transform-stroke',
	'transform-view',
	'transition-discrete',
	'transition-normal',
	'translate-3d',
	'translate-full',
	'translate-none',
	'translate-px',
	'translate-x-full',
	'translate-x-px',
	'translate-y-full',
	'translate-y-px',
	'translate-z-px',
	'truncate',
	'underline',
	'uppercase',
	'via-none',
	'visible',
	'w-auto',
	'w-dvh',
	'w-dvw',
	'w-fit',
	'w-full',
	'w-lvh',
	'w-lvw',
	'w-max',
	'w-min',
	'w-px',
	'w-screen',
	'w-svh',
	'w-svw',
	'whitespace-break-spaces',
	'whitespace-normal',
	'whitespace-nowrap',
	'whitespace-pre',
	'whitespace-pre-line',
	'whitespace-pre-wrap',
	'will-change-auto',
	'will-change-contents',
	'will-change-scroll',
	'will-change-transform',
	'wrap-anywhere',
	'wrap-break-word',
	'wrap-normal',
])

export const UTILITY_PREFIXES = new Set([
	'-backdrop-hue-rotate',
	'-bg-conic',
	'-bg-linear',
	'-bottom',
	'-col',
	'-col-end',
	'-col-start',
	'-end',
	'-hue-rotate',
	'-indent',
	'-inset',
	'-inset-x',
	'-inset-y',
	'-left',
	'-m',
	'-mask-conic',
	'-mask-linear',
	'-mb',
	'-me',
	'-ml',
	'-mr',
	'-ms',
	'-mt',
	'-mx',
	'-my',
	'-order',
	'-outline-offset',
	'-right',
	'-rotate',
	'-rotate-x',
	'-rotate-y',
	'-rotate-z',
	'-row',
	'-row-end',
	'-row-start',
	'-scale',
	'-scale-x',
	'-scale-y',
	'-scale-z',
	'-scroll-m',
	'-scroll-mb',
	'-scroll-me',
	'-scroll-ml',
	'-scroll-mr',
	'-scroll-ms',
	'-scroll-mt',
	'-scroll-mx',
	'-scroll-my',
	'-skew',
	'-skew-x',
	'-skew-y',
	'-space-x',
	'-space-y',
	'-start',
	'-top',
	'-tracking',
	'-translate',
	'-translate-x',
	'-translate-y',
	'-translate-z',
	'-underline-offset',
	'-z',
	'@container',
	'accent',
	'align',
	'animate',
	'aspect',
	'auto-cols',
	'auto-rows',
	'backdrop-blur',
	'backdrop-brightness',
	'backdrop-contrast',
	'backdrop-filter',
	'backdrop-grayscale',
	'backdrop-hue-rotate',
	'backdrop-invert',
	'backdrop-opacity',
	'backdrop-saturate',
	'backdrop-sepia',
	'basis',
	'bg',
	'bg-conic',
	'bg-linear',
	'bg-position',
	'bg-radial',
	'bg-size',
	'blur',
	'border',
	'border-b',
	'border-e',
	'border-l',
	'border-r',
	'border-s',
	'border-spacing',
	'border-spacing-x',
	'border-spacing-y',
	'border-t',
	'border-x',
	'border-y',
	'bottom',
	'brightness',
	'caret',
	'col',
	'col-end',
	'col-span',
	'col-start',
	'columns',
	'contain',
	'content',
	'contrast',
	'cursor',
	'decoration',
	'delay',
	'divide',
	'divide-x',
	'divide-y',
	'drop-shadow',
	'duration',
	'ease',
	'end',
	'fill',
	'filter',
	'flex',
	'flex-grow',
	'flex-shrink',
	'font',
	'font-stretch',
	'from',
	'gap',
	'gap-x',
	'gap-y',
	'grayscale',
	'grid-cols',
	'grid-rows',
	'grow',
	'h',
	'hue-rotate',
	'indent',
	'inset',
	'inset-ring',
	'inset-shadow',
	'inset-x',
	'inset-y',
	'invert',
	'leading',
	'left',
	'line-clamp',
	'list',
	'list-image',
	'm',
	'mask',
	'mask-b-from',
	'mask-b-to',
	'mask-conic',
	'mask-conic-from',
	'mask-conic-to',
	'mask-l-from',
	'mask-l-to',
	'mask-linear',
	'mask-linear-from',
	'mask-linear-to',
	'mask-position',
	'mask-r-from',
	'mask-r-to',
	'mask-radial',
	'mask-radial-at',
	'mask-radial-from',
	'mask-radial-to',
	'mask-size',
	'mask-t-from',
	'mask-t-to',
	'mask-x-from',
	'mask-x-to',
	'mask-y-from',
	'mask-y-to',
	'max-h',
	'max-w',
	'max-w-screen',
	'mb',
	'me',
	'min-h',
	'min-w',
	'ml',
	'mr',
	'ms',
	'mt',
	'mx',
	'my',
	'object',
	'opacity',
	'order',
	'origin',
	'outline',
	'outline-offset',
	'p',
	'pb',
	'pe',
	'perspective',
	'perspective-origin',
	'pl',
	'placeholder',
	'pr',
	'ps',
	'pt',
	'px',
	'py',
	'right',
	'ring',
	'ring-offset',
	'rotate',
	'rotate-x',
	'rotate-y',
	'rotate-z',
	'rounded',
	'rounded-b',
	'rounded-bl',
	'rounded-br',
	'rounded-e',
	'rounded-ee',
	'rounded-es',
	'rounded-l',
	'rounded-r',
	'rounded-s',
	'rounded-se',
	'rounded-ss',
	'rounded-t',
	'rounded-tl',
	'rounded-tr',
	'row',
	'row-end',
	'row-span',
	'row-start',
	'saturate',
	'scale',
	'scale-x',
	'scale-y',
	'scale-z',
	'scroll-m',
	'scroll-mb',
	'scroll-me',
	'scroll-ml',
	'scroll-mr',
	'scroll-ms',
	'scroll-mt',
	'scroll-mx',
	'scroll-my',
	'scroll-p',
	'scroll-pb',
	'scroll-pe',
	'scroll-pl',
	'scroll-pr',
	'scroll-ps',
	'scroll-pt',
	'scroll-px',
	'scroll-py',
	'sepia',
	'shadow',
	'shrink',
	'size',
	'skew',
	'skew-x',
	'skew-y',
	'space-x',
	'space-y',
	'start',
	'stroke',
	'text',
	'text-shadow',
	'to',
	'top',
	'tracking',
	'transform',
	'transition',
	'translate',
	'translate-x',
	'translate-y',
	'translate-z',
	'underline-offset',
	'via',
	'w',
	'will-change',
	'z',
])
